<template>
    <div>
      <div class="selected-valve" @click="$emit('edit', additionalValveIndex)">
        <img :src="getFromStorage(currentAdditionalValve.schematic_image)" alt="" v-if="currentAdditionalValve.schematic_image">
        <div class="whitespace" v-else>
        </div>
        <div class="info">
            <span class="name">
              {{ currentAdditionalValve.name.nl }}
            </span>
        </div>
      </div>

      <div class="label-delete" @click="deleteAdditionalValve">
        <span class="inner">
          {{ $t('powerpack.menu.valvePopup.removeAdditional') }}
        </span>
      </div>
    </div>
</template>

<script>
  import { mapMutations, mapState } from "vuex";
  import InputDropdown from "../input/Dropdown"
  import { getFromStorage } from "@/helpers/backendStorage";

  export default {
    name: "PopupValveAdditionalValves",

    components: { InputDropdown },

    props: {
      additionalValveId: {
        required: true,
        type: Number
      },
      additionalValveIndex: {
        required: true,
        type: Number,
      },
      valveIndex: {
        required: true,
        type: Number,
      },
      used: {
        type: Array,
        default: () => []
      },
    },
    computed: {
      currentAdditionalValve() {
        return this.$store.getters["additionalValves/getById"](this.additionalValveId);
      },
      ...mapState({
        additionalValves: state => state.additionalValves.all,
      }),
    },
    methods: {
      getFromStorage,
      ...mapMutations({
        update: 'build/valves/updateAdditionalValve',
        delete: 'build/valves/removeAdditionalValve',
      }),
      deleteAdditionalValve() {
        this.delete({
          valveIndex: this.valveIndex,
          index: this.additionalValveIndex
        });
      }
    }
  }
</script>

<style scoped lang="scss">
    .form-control {
        border-radius: 50px;
        border: 2px solid #EBEBEB;
        font-size: 12px;
        height: 40px;

        &:active, &:focus {
            outline: none;
            box-shadow: none;
        }
    }
    .label-delete {
        display: flex;
        justify-content: flex-end;
        cursor: pointer;
        margin-bottom: 10px;

        .inner {
            text-decoration: underline;
            font-size: 12px;

            img {
                margin-right: 4px;
            }
        }
    }


    .selected-valve {
      max-width: 270px;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-content: center;
      background-color: white;
      box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.3);
      padding: 10px;
      margin-bottom: 15px;
      text-align: center;
      transition: all ease 0.3s;
      cursor: pointer;

      &:hover {
        transform: scale(1.05);
      }

      img {
        max-width: 100%;
        padding: 10px 0;
        height: auto;
      }

      .whitespace {
        background-color: white;
        width: 100%;
        margin: 8px auto;
        height: auto;
        min-height: 163px;
      }

      .info {
        margin: 0 auto;
        display: flex;
        width: 100%;
        justify-content: center;
        align-content: center;
        transition: all ease 0.3s;
        font-size: 12px;

        .name {
          transition: all ease 0.5s;
          color: black;
          font-weight: bold;
        }
      }
    }

</style>
